import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const DrAndreaTomeo = () => {
  return (
    <div className="container p-0">
      {/* Hero Section */}
      <section className="row g-0 bg-light align-items-stretch">
        <div className="col-lg-6 d-flex">
          <div className="w-100" style={{ minHeight: "500px" }}>
            <img
              src="https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/dr-768x768.jpg"
              alt="Dr. Andrea Tomeo"
              className="img-fluid h-100 w-100 object-fit-cover"
              loading="lazy"
            />
          </div>
        </div>
        <div className="col-lg-6 p-4 p-lg-5 d-flex align-items-center">
          <div className="w-100">
            <h1 className="display-4 mb-3" style={{ color: "#c69933" }}>
              Dr. Andrea Tomeo
            </h1>
            <h5 className="text-muted mb-2">PhD. MD. MSc. MBA. BSc.</h5>
            <h5 className="text-muted mb-4">
              Director of Education & Medical Compliance PhD in Stem Cells &
              Regenerative Medicine
            </h5>

            <div className="bg-white p-4 rounded shadow-sm mb-4">
              <p className="mb-2">
                <strong style={{ color: "#bdaa7d" }}>SPECIALITY:</strong>{" "}
                Cosmetic Surgeon, Medical Aesthetics, Clinical Anti-Aging
                Medicine, Regenerative Medicine, Integrated Medicine, and Sexual
                Well Being
              </p>
              <p className="mb-2">
                <strong style={{ color: "#bdaa7d" }}>NATIONALITY:</strong>{" "}
                Italian
              </p>
              <p className="mb-0">
                <strong style={{ color: "#bdaa7d" }}>LANGUAGE:</strong> English,
                Italian, Arabic, Spanish, Portuguese
              </p>
            </div>

            <div className="d-flex flex-wrap gap-3">
              <a
                href="/contact-us/"
                className="btn px-4 py-2 text-white fw-bold"
                style={{ backgroundColor: "#c69933", borderColor: "#c69933" }}
              >
                Book an Appointment
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h2
                className="text-center mb-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                About Dr. Andrea Tomeo
              </h2>
              <p className="lead text-center mb-5" style={{ color: "#bdaa7d" }}>
                A Visionary Leader in Aesthetic Industry
              </p>

              <div className="card border-0 shadow-sm mb-5">
                <div className="card-body p-4">
                  <ul className="list-unstyled">
                    {[
                      "Trailblazer in medical aesthetics, cosmetic, anti-aging and regenerative medicine with extensive knowledge and experience.",
                      "Recognized for commitment to excellence, passion for education, and delivering confidence and beauty patients deserve.",
                      "Director of Education & Medical Compliance at Elite Polyclinic & Academy, leading innovative educational initiatives.",
                      "Holds key leadership positions including CEO/Partner and Director of Scientific & Medical Operations.",
                      "Renowned celebrity doctor trusted by high-profile clients and A-listers worldwide.",
                    ].map((item, index) => (
                      <li key={index} className="mb-3 d-flex">
                        <span
                          className="badge rounded-circle me-3 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#c69933",
                            color: "white",
                            width: "30px",
                            height: "30px",
                            flexShrink: 0,
                          }}
                        >
                          {index + 1}
                        </span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <h3 className="fw-bold mb-4" style={{ color: "#c69933" }}>
                Education & Professional Background
              </h3>

              <div className="row g-4 mb-5">
                {[
                  {
                    title: "PhD in Regenerative Medicine",
                    description:
                      "Advanced strategies for modern medicine at the doctoral level.",
                  },
                  {
                    title: "Master's in Aesthetic Medicine",
                    description:
                      "Postgraduate studies in advanced cosmetic techniques from the prestigious Medical University of Nice, France.",
                  },
                ].map((item, index) => (
                  <div key={index} className="col-md-6">
                    <div className="card h-100 border-0 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title" style={{ color: "#bdaa7d" }}>
                          {item.title}
                        </h5>
                        <p className="card-text">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Accordion */}
              <div className="accordion mb-5" id="aboutAccordion">
                <div className="accordion-item border-0 shadow-sm mb-3">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button fw-bold py-3"
                      type="button"
                      style={{ backgroundColor: "#f8f9fa", color: "#c69933" }}
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Professional Details
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#aboutAccordion"
                  >
                    <div className="accordion-body">
                      <h5 className="fw-bold mb-3" style={{ color: "#c69933" }}>
                        Professional Affiliations
                      </h5>
                      <ul className="mb-4">
                        <li className="mb-2">
                          Faculty Member and CSO, British Board of Anti-Ageing &
                          Integrated Medicine (BBAIM)
                        </li>
                        <li className="mb-2">
                          Member of the Royal Society of Medicine
                        </li>
                        <li className="mb-2">Associate University Professor</li>
                      </ul>

                      <h5 className="fw-bold mb-3" style={{ color: "#c69933" }}>
                        Awards & Certificates
                      </h5>
                      <div className="row g-3">
                        {[
                          {
                            title: "Certificate of Appreciation",
                            description: "Indian Society of Aesthetic Medicine",
                          },
                          {
                            title: "Master in Superficial Facial Anatomy",
                            description:
                              "Critical component of aesthetic capability",
                          },
                        ].map((item, index) => (
                          <div key={index} className="col-md-6">
                            <div
                              className="p-3 rounded"
                              style={{ backgroundColor: "#f8f9fa" }}
                            >
                              <h6 style={{ color: "#bdaa7d" }}>{item.title}</h6>
                              <p className="mb-0">{item.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold" style={{ color: "#c69933" }}>
            Gallery
          </h2>
          <div className="row g-3">
            {[
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/4.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/6.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/5.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/3.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/Andrea22.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/Andrea2d2.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/71-1.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/48-1.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/70-1.jpg",
              "https://darkslategrey-lion-344341.hostingersite.com/wp-content/uploads/2024/12/29.jpg",
            ].map((imgSrc, index) => (
              <div key={index} className="col-6 col-md-4 col-lg-3">
                <div className="card border-0 shadow-sm overflow-hidden">
                  <img
                    src={imgSrc}
                    className="img-fluid w-100"
                    style={{ height: "250px", objectFit: "cover" }}
                    alt={`Dr. Andrea Tomeo ${index + 1}`}
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DrAndreaTomeo;
